/*
 * @Author: 智客云网络科技
 * @Date: 2022-02-06 17:57:55
 * @LastEditors: 阡陌OvO
 * @LastEditTime: 2022-04-11 12:06:42
 * @Description: 路由管理
 * @FilePath: \src\router\index.js
 */

import { nextTick } from "vue";
import { createRouter, createWebHistory } from "vue-router";
import { myStore } from "@/store";
import staticRoute from "./routes"; //静态路由
import activeNav from "./MenuLinkage"; //菜单-导航-路由 联动模块
import { getMenuConfigApi } from "@/api/module/Global"; //公共Api接口

const store = myStore();

//定义404路由
const Route404 = {
  id: "page404",
  title: "404",
  name: "404",
  path: "/(.*)",
  component: () => import(`@/views/404.vue`),
};

const router = createRouter({
  history: createWebHistory(),
  routes: staticRoute,
});

/**
 * 注册一个全局前置守卫
 * to:即将要进入的目标路由对象
 * from:当前导航正要离开的路由
 * next:一定要调用该方法来 resolve 这个钩子
 */
router.beforeEach((to, from, next) => {
  //切换到导航
  activeNav(to);

  //登录界面登录成功之后，会把用户信息及Token保存在localStorage
  let Token = localStorage.getItem("token"); //仅登录成功后才存在Token
  if (to.path === "/Login") {
    //如果是访问登录界面并且Token存在 则代表已登录过 跳转到主页
    //否则继续进入登录页面
    if (Token) {
      next({ path: "/Home" });
    } else {
      next();
    }
  } else if (to.meta.verify) {
    //如果访问的不是登录界面，且路由需要登录
    //判断Token是否存在 不存在代表未登录，跳转到登录
    //否则如果Token存在则代表一登录 写入信息后跳转到目标页面
    if (!Token) {
      next({ path: "/Login" });
    } else {
      setUserInfo(); //写入用户信息
      loadMenuAndRoutes(to, from, next); //添加动态菜单和路由后直接跳转
    }
  } else {
    //不需要登录 写入信息后跳转到目标页面
    setUserInfo(); //写入用户信息
    loadMenuAndRoutes(to, from, next); //添加动态菜单和路由后，直接跳转
  }
});

/**
 * 加载菜单和路由
 * @param {Object} to
 * @param {Object} from
 * @param {function} next
 * @returns
 */
function loadMenuAndRoutes(to, from, next) {
  //如果路由和菜单已加载则调用next();
  if (
    store.state["MenuModule"]["menuStatus"] &&
    store.state["RouterModule"]["routerStatus"]
  ) {
    next();
    return;
  }

  //优先从本地sessionStorage获取路由和导航菜单配置
  let MrData = localStorage.getItem("MrData");

  //测试环境下始终从服务器获取最新的菜单
  if (process.env.NODE_ENV !== "production") {
    MrData = null;
  }

  if (MrData) {
    //写入路由配置
    let set_router_config = setRouterConfig(JSON.parse(MrData));

    //写入导航菜单配置
    let set_nav_bar_config = setMenuConfig(JSON.parse(MrData));

    if (set_router_config && set_nav_bar_config) {
      //检测首页是否打开过
      if (!store.state["MenuModule"]["homeOpenState"]) {
        store.commit("WebModule/setJumpTarget", "Inner", to.name);
        nextTick(() => {
          next({ path: "/Home" });
        });
      } else {
        next({ ...to });
      }
    } else {
      next({ path: "/Login" });
    }
  } else {
    //本地sessionStorage获取不到，从服务器拉取
    getMenuConfigApi()
      .then((res) => {
        let config = res.data;

        //写入localStorage
        localStorage.setItem("MrData", JSON.stringify(config));

        //写入路由配置
        let set_router_config = setRouterConfig(config);

        //写入导航菜单配置
        let set_nav_bar_config = setMenuConfig(config);

        if (set_router_config && set_nav_bar_config) {
          //检测首页是否打开过
          if (!store.state["MenuModule"]["homeOpenState"]) {
            store.commit("WebModule/setJumpTarget", "Inner", to.name);
            nextTick(() => {
              next({ path: "/Home" });
            });
          } else {
            next({ ...to });
          }
        } else {
          next({ path: "/Login" });
        }
      })
      .catch((res) => {
        console.log(res);
      });
  }
}

/**
 * 设置路由配置
 * @param {object} routerConfig 路由配置
 */
function setRouterConfig(routerConfig) {
  //验证数据类型
  if (typeof routerConfig !== "object") {
    return false;
  }

  //检查列表是否为空
  if (routerConfig.length < 1) {
    //终止程序
    return false;
  }

  //构建路由
  let BuildRouteCache = buildRouterConfig(routerConfig);
  if (BuildRouteCache.length > 0) {
    for (let i = 0; i < BuildRouteCache.length; i++) {
      const routers = BuildRouteCache[i];
      router.addRoute("Main", routers);
    }
  }

  router.addRoute(Route404); //插入404路由
  store.commit("RouterModule/setOriginalRoutes", routerConfig); //写入原始路由表
  store.commit("RouterModule/setRoutes", router.getRoutes()); //写入路由表
  store.commit("RouterModule/setRouterStatus", true); //设置路由为已加载状态

  return true;
}

/**
 * 构建路由配置
 * @param {array} routerConfig 路由配置
 */
function buildRouterConfig(routerConfig) {
  let BuildRouteCache = []; //路由构建缓存
  for (let i = 0; i < routerConfig.length; i++) {
    let data = routerConfig[i]; //取出数据

    //定义路由数据
    if (data.type == "x104015") {
      let routers = {
        name: data.route, //命名路由
        path: data.route, //路径
        component: () => import(`@/views/${data.uri}`), //命名视图组件
        // components: "", //命名视图组件
        // redirect: "", //重定向路径
        // alias: "", //别名
        // children: "", //嵌套路由
        // caseSensitive: false, //匹配规则是否大小写敏感?(默认 false)
        // pathToRegexpOptions: "", //编译正则的选项
        meta: {
          menu_id: data.menu_id, //对应的菜单ID
          verify: data.verify, //认证标识
        }, //路由元信息 route.meta.属性 可以获取
      };

      BuildRouteCache.push(routers);
    }

    //判断是否有子级路由
    if (data.childList && data.childList.length > 0) {
      let subConfig = buildRouterConfig(data.childList);
      if (subConfig.length > 0) {
        for (let subIndex = 0; subIndex < subConfig.length; subIndex++) {
          const subRC = subConfig[subIndex];
          BuildRouteCache.push(subRC);
        }
      }
    }
  }

  return BuildRouteCache;
}

/**
 * 设置导航菜单配置
 * @param {object} menuConfig 导航菜单配置
 */
function setMenuConfig(menuConfig) {
  //验证数据类型
  if (typeof menuConfig !== "object") {
    return false;
  }

  //检查列表是否为空
  if (menuConfig.length < 1) {
    //终止程序
    return false;
  }

  const BuildMenuCache = buildMenuConfig(menuConfig); //构建菜单配置
  store.commit("MenuModule/setOriginalMenuConfig", menuConfig); //写入原始菜单配置
  store.commit("MenuModule/setMenuConfig", BuildMenuCache); //写入菜单配置
  store.commit("MenuModule/setMenuStatus", true); //设置菜单为已加载状态

  return true;
}

/**
 * 构建菜单配置
 * @param {array} menuConfig 菜单配置
 */
function buildMenuConfig(menuConfig) {
  let BuildMenuCache = []; //导航菜单构建缓存
  for (let i = 0; i < menuConfig.length; i++) {
    let data = menuConfig[i]; //取出数据

    //定义菜单数据
    let menu = {
      id: data.menu_id, //菜单ID
      show: data.show, //菜单是否显示
      type: data.type, //菜单类型
      verify: data.verify, //菜单是否需要认证
      name: data.name, //菜单显示名称
      route: data.route, //菜单对应路由名
      icon: data.icon || "", //菜单图标
    };

    //判断是否有子级菜单
    if (data.childList && data.childList.length > 0) {
      let subConfig = buildMenuConfig(data.childList);
      if (subConfig.length > 0) {
        menu.childList = subConfig; //写入子级菜单
      }
    }

    BuildMenuCache.push(menu); //导航菜单构建缓存
  }

  return BuildMenuCache;
}

/**
 * 向Vuex内写入用户信息
 */
function setUserInfo() {
  //设置用户信息
  var userinfo = localStorage.getItem("userinfo");
  var token = localStorage.getItem("token");

  if (userinfo && token) {
    var uf = JSON.parse(userinfo);
    store.commit("UserModule/setUserName", uf.username); //用户名
    store.commit("UserModule/setNickName", uf.nickname); //用户昵称
    store.commit("UserModule/setSign", uf.sign); //个签
    store.commit("UserModule/setAvatar", uf.avatar); //头像
    store.commit("UserModule/setLoginStatus", true); //写入登录态
    store.commit("UserModule/setToken", token); //token

    return true;
  }

  return false;
}

export default router;
